
import { Header } from 'src/pages/analytics/simulator/pricing-simulator/types/generic-table.model';
import { getParentRows } from '../../utils/table-utils';

export default function getSelectCheckboxInputChange({
    columnMetadata,
    parentRow,
    newInputValue,
    rowIndices
}:
    {
        parentRow: any;
        columnMetadata: Header;
        newInputValue: number | string;
        rowIndices: number[]
    }) {
    const parentRows = getParentRows(parentRow, columnMetadata, newInputValue, rowIndices);
    parentRows.forEach(row => {
        if (row.children && row.children.length) {
            // eslint-disable-next-line no-param-reassign
            row.parent.data[columnMetadata.parent.parent_field] = row.children.every(childRow => !!childRow.parent.data[columnMetadata.parent.parent_field]) ? 1 : 0;
        } else {
            // eslint-disable-next-line no-param-reassign
            row.parent.data[columnMetadata.parent.parent_field] = newInputValue;
        }
    });
}